import ReactDOM from 'react-dom';

import { memoize } from 'lodash-es';
import { BehaviorSubject } from 'rxjs';
import { Menu } from './components/menu/Menu';
import profile from './profile';

export const getGlobalForceMenuOpenById$ = memoize(() => new BehaviorSubject());

export function menuModule({ options: { elementId } }) {
    const forceMenuOpenById$ = getGlobalForceMenuOpenById$();
    ReactDOM.render(
        <Menu profile={profile} forceMenuOpenById$={forceMenuOpenById$} />,
        document.getElementById(elementId)
    );
}
